import React, { Component } from 'react';
import '../../css/style.css';
import '../Home.css';
import { Button, Form, OverlayTrigger, Tooltip, Row, Col } from 'react-bootstrap';
import { FACEBOOK_URL, TWITTER_URL, WHATSAPP_URL } from '../../backend/Backend';
import { translate } from "react-i18next";


class Sharing extends Component {

  constructor(props) {
    super(props);
    this.handleCopy = this.handleCopy.bind(this);
    this.state = {
      copied: false
    }
  }


  handleCopy() {
    navigator.clipboard.writeText(this.props.url);
    this.setState({ copied: true })
  }

  render() {
    const { t } = this.props;
    return (
      <div>
        
        <Form inline>
          {this.props.shareLabel ?
            <Form.Label className="mr-3">{t("share")}</Form.Label>
            : ""
          }
          <a href={`${WHATSAPP_URL}${encodeURIComponent(this.props.url)}`} data-href={`${WHATSAPP_URL}DATA`} data-action="share/whatsapp/share"
            role="link" tabindex="1" target="_blank" data-channel="whatsapp" className="mr-2" ><i class="fab fa-whatsapp-square s24"></i></a>
          {this.props.facebook ?
            <a href={`${FACEBOOK_URL}${encodeURIComponent(this.props.url)}`} data-href={`${FACEBOOK_URL}DATA`}
              role="link" tabindex="1" target="_blank" data-channel="facebook" className="mr-2" ><i className=" fab fa-facebook-square s24 " ></i></a>
            :
            ""
          }
          {this.props.twitter ?
            <a href={`${TWITTER_URL}${encodeURIComponent(this.props.url)}`} data-href={`${TWITTER_URL}DATA`}
              role="link" tabindex="1" target="_blank" data-channel="twitter" className="mr-2"><i className=" fab fa-twitter-square s24 " ></i></a>
            :
            ""
          }

          <Form.Control size="sm" type="text" value={this.props.url} disabled={true} inline   style={{width:"300px"}} />

          <OverlayTrigger
            key="top"
            placement="top"
            overlay={
              <Tooltip id={`tooltip-top`}>
                {t("copyLink")}
              </Tooltip>
            }>
            <Button onClick={this.handleCopy} variant="link" inline >
              <i class="far fa-copy s24 inL"></i>
            </Button>
          </OverlayTrigger>



          {this.state.copied ?
            <Form.Label>{t("copied")}</Form.Label>
            : ''}

        </Form>
        {this.props.title ?
          <Row>
            <Col>
            <Form.Text className="text-muted">
              {this.props.title}
            </Form.Text>
            </Col>
          </Row>
          :
          ""
        }
      </div>
    );
  }

}
export default translate("translations")(Sharing);